module.exports = __webpack_public_path__ + "static/img/lunbo3.6db9a5d4.webp";